module.exports = __webpack_public_path__ + "img/mezentsev.835fac61.jpg";